import * as tslib_1 from "tslib";
import deleteUserConfigurationOperation from 'owa-service/lib/operation/deleteUserConfigurationOperation';
import deleteUserConfigurationRequest from 'owa-service/lib/factory/deleteUserConfigurationRequest';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import getMailboxExportUserConfigurationName from './getMailboxExportUserConfigurationName';
export default function deleteMailboxExportRequest() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, deleteUserConfigurationOperation({
                        Header: getJsonRequestHeader(),
                        Body: deleteUserConfigurationRequest({
                            UserConfigurationName: getMailboxExportUserConfigurationName(),
                        }),
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=deleteMailboxExportRequest.js.map